import { render, staticRenderFns } from "./UpdateTask.vue?vue&type=template&id=b929de4e&"
import script from "./UpdateTask.ts?vue&type=script&lang=ts&"
export * from "./UpdateTask.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports